import { Component, OnInit, ViewChild } from '@angular/core';

import { Config } from 'src/app/models/env-vars.model';
import { AppData } from 'src/app/services/appdata.service';
import { API } from 'src/app/services/api.service';
import { alertService } from 'src/app/services/alert-service.service';
import { Global } from 'src/app/services/global.service';

import { ModalComponent } from 'src/app/components/modal/modal.component';

import 'moment-timezone';
import * as moment from 'moment';
import * as stream from 'getstream';

@Component({
  selector: 'app-eu-taxonomy',
  templateUrl: './eu-taxonomy.component.html',
  styleUrls: ['./eu-taxonomy.component.css']
})
export class EuTaxonomyComponent implements OnInit
{
	@ViewChild('new_survey') private new_survey!: ModalComponent;
	@ViewChild('download_survey') private download_survey!: ModalComponent;
	@ViewChild('check_survey') private check_survey!: ModalComponent;
	config = Config;
	
	loading: boolean = false;
	picker_loaded: boolean = false;
	uploading: boolean = false;
	errors: boolean = false;
	error_year: boolean = false;

	current_step: number = 0;
	leed_id: number = this.appData.get('leed_id');

	state_full: string = '';
	country_full: string = '';
	download_type: string = '';
	mode: string = '';
	user_role: string = this.appData.get('user_role')

	selected_survey: any = null;
	surveys: any = [];
	survey_template: any = [];
	feed_report: any = [];
	download_options: any = [
		{
			"label": "Summary Report",
			"type": "summary",
			"description": "Self-assessment highlights, including asset characteristics, environmental objectives, Do No Significant Harm, and Minimum Safeguards."
		},
		{
			"label": "Documentation",
			"type": "documentation",
			"description": "Full self-assessment results, including summary, responses, and documentation."
		}
	];
	styles: any = "<style>#myCanvas,#myCanvas th{font-family:Gothic}@font-face{src:url(https://api.usgbc.org/arc/static/fonts/GOTHIC.TTF?subscription-key=5a41833022f046dc951383ead38d16d3);font-family:Gothic}@font-face{src:url(https://api.usgbc.org/arc/static/fonts/GOTHICB.TTF?subscription-key=5a41833022f046dc951383ead38d16d3);font-family:GothicBold}#myCanvas{background-color:#f4f5f8!important}#myCanvas .cert_appLogo{background:url("+ this.config.config.settings.s3_bucket_url +"/assets/images/arc-logo-white.png) 50%/contain no-repeat;height:80px;margin-top:125px}.certificate{margin:0px auto;width:11in;height:8.89in;background-color:#fff;display:flex}#myCanvas #cert_banner{width:25%}#myCanvas #cert_content{width:75%;text-align:center;background-color:#fff;position:relative}#myCanvas .mb5{margin-bottom:2px!important}#myCanvas .heading1{margin-top:20px;margin-bottom:20px;font-size:10pt;color:#75818a;font-family:GothicBold;font-weight:600}#myCanvas .heading2{margin-bottom:15px;font-size:10pt;color:#75818a}#myCanvas .heading3{margin-bottom:15px;font-size:10pt;line-height:25px}#myCanvas .category,#myCanvas .metrics{margin:0 50px 20px;border-bottom:1px solid #dce1e2}#myCanvas #project_name{font-family:GothicBold;font-size:24pt;font-weight:400;margin:0}#myCanvas #project_address,#myCanvas .category,#myCanvas .metrics .heading{font-weight:600;font-family:GothicBold}#myCanvas #project_address{font-size:10pt;margin-top:10px;margin-bottom:20px}#myCanvas .category{padding:0 0 20px;font-size:16pt}#myCanvas .metrics{overflow:auto;padding-bottom:20px;display:flex}#myCanvas .metrics .heading{color:#75818a;font-size:10pt;margin-bottom:10px}#myCanvas .cert_block{height:5px;width:30px;margin-bottom:10px;background-color:#253a3d}#myCanvas .value{font-family:GothicBold;font-weight:400;margin:0;color:#75818a;text-align:left;font-size:27px}#myCanvas .cert_bold,#myCanvas .value span{color:#000;font-family:GothicBold;font-weight:600}#myCanvas .data{font-size:10pt;overflow:auto;line-height:18pt;color:#75818a;position:relative}#myCanvas .right{position:absolute;right:0}#myCanvas .mb27{margin-bottom:27px}#myCanvas .heading4{margin-bottom:15px;font-size:9px;font-family:GothicBold;font-weight:600}#myCanvas .mb0{margin-bottom:0}#myCanvas .signature{background:url("+ this.config.config.settings.s3_bucket_url +"/assets/images/sig.png) 55%/contain no-repeat;height:45px;border-bottom:1px solid #dce1e2;margin:25px 115px 10px}#myCanvas .cert_grey{color:#75818a}#myCanvas .key_metrics{width:55%;text-align:left}#myCanvas .main_score{width:45%;text-align:left}#myCanvas .rt10{position:relative;top:30px}#myCanvas .footer{position:absolute;bottom:40px;width:100%}#myCanvas .bold{font-weight:700}#myCanvas .energy_banner_gradient{background:linear-gradient(to bottom left,#273c40 0,#375e76 100%)}#myCanvas .mt45{margin-top:45px}#myCanvas .waste_banner_gradient{background:linear-gradient(to bottom left,#275d8d 0,#4cb0db 100%)}#myCanvas td{font-family:GothicBold;padding:10px 0!important;font-size:14px}.ml25{margin-left:25px!important}.w100p{width:100%!important}th{font-size:14px;line-height:24px;font-weight:500}.done_green_icon{background:url("+ this.config.config.settings.s3_bucket_url +"/assets/images/done_green_icon.svg) 0 0/contain no-repeat;width:25px;height:32px;margin-left: 20px;}.not_done_icon{background:url("+ this.config.config.settings.s3_bucket_url +"/assets/images/notdone_x_icon.svg) 0 0/contain no-repeat;width:25px;height:32px;margin-left: 20px;}.w25px{width: 25px!important;}</style>";

	constructor(
		public global: Global,
		public appData: AppData,
		private api: API,
		private alertService: alertService
	)
	{}

	ngOnInit(): void
	{
		if(this.appData.get('buildingData').arctool_permission)
        {
            this.user_role = 'arc_pro';
        }
		
		this.global.fetchCountryStates().subscribe(
			data =>
			{
				Config.countries = data;
				this.state_full = this.global.getState(this.appData.get('buildingData').state, this.appData.get('buildingData').country);
				this.country_full = this.global.getCountry(this.appData.get('buildingData').country);

				if(this.state_full == '')
				{
					this.state_full = 'Not Available';
				}
			}
		);

		this.api.getAsset(
			'../../../../assets/json/euSurvey.json'
		).subscribe(
			data => 
			{
				this.survey_template = data;
			}
		);
		
		this.getSurveys();
		this.initFeed();
	}

	insertChildrenData(option: any, data_row: any): number
    {
        if(option.children != undefined)
        {
            for(let i = 0; i < option.children.length; i++)
            {
                option.children[i].radio_value = data_row[option.children[i].key];
				option.children[i].textarea_value = data_row[option.children[i].key + "_reason"];
				option.children[i].upload_value = data_row[option.children[i].key + "_upload"];

				if(option.children[i].has_model)
				{
					option.children[i].upload_label_model = data_row[option.children[i].key + "_reading"];
				}

				if(option.children[i].flipped != undefined && option.children[i].flipped)
				{
					option.children[i].radio_value = !option.children[i].radio_value;
				}

				data_row = this.insertChildrenData(option.children[i], data_row);
            }
        }
        return data_row;
    }

	insertData(data: any)
	{
		data.filter((data_row: any) =>
		{
			for(let idx = 0; idx < this.survey_template.length; idx++)
			{
				if(data_row.survey_type == this.survey_template[idx].survey_type)
				{
					Object.assign(
						this.survey_template[idx].steps[0],
						data_row.projectinfo
					);

					for(let idx2 = 0; idx2 < this.survey_template[idx].steps.length; idx2 ++)
					{
						let obj = this.survey_template[idx].steps[idx2];
						if('questions' in obj)
						{
							for(let idx3 = 0; idx3 < obj.questions.length; idx3++)
							{
								obj.questions[idx3].radio_value = data_row[obj.key][obj.questions[idx3].key];
								obj.questions[idx3].textarea_value = data_row[obj.key][obj.questions[idx3].key + "_reason"];
								obj.questions[idx3].upload_value = data_row[obj.key][obj.questions[idx3].key + "_upload"];

								if(obj.questions[idx3].has_model)
								{
									obj.questions[idx3].upload_label_model = data_row[obj.key][obj.questions[idx3].key + "_reading"];
								}

								if(obj.questions[idx3].flipped != undefined && obj.questions[idx3].flipped)
								{
									obj.questions[idx3].radio_value = !obj.questions[idx3].radio_value;
								}

								data_row[obj.key] = this.insertChildrenData(obj.questions[idx3], data_row[obj.key]);
							}
						}
					}

					this.survey_template[idx].completion = data_row.completion;
					this.survey_template[idx].compliance = data_row.compliance;
					this.survey_template[idx].created_at = data_row.created_at;
					this.survey_template[idx].surveycompleted = data_row.surveycompleted;
					this.survey_template[idx].id = data_row.id;
					break;
				}
			}
		})
		return this.survey_template;
	}

    getChildrenSteps(option: any): number
    {
        let counter = 0;
        if(option.children != undefined && option.radio_value)
        {
            counter += option.children.length;
            for(let i = 0; i < option.children.length; i++)
            {
                counter += this.getChildrenSteps(option.children[i]);
            }
        }
        return counter;
    }

    getChildrenCompletion(option: any): number
    {
        let counter = 0;
        if(option.children != undefined)
        {
            for(let i = 0; i < option.children.length; i++)
            {
                if(
                    (option.children[i].radio_value && option.children[i].upload_value == undefined) ||
                    (option.children[i].radio_value && option.children[i].upload_value.length > 0) ||
                    (option.children[i].radio_value == false)
                )
                {
                    counter += 1;
                }

                if(option.children != undefined)
                {
                    counter += this.getChildrenCompletion(option.children[i]);
                }
            }
        }
        return counter;
    }

	getCompletion(survey: any)
	{
		let completion = 0;
		if("id" in survey)
		{
			for(let i = 0; i < survey.steps.length; i++)
			{
				let step = survey.steps[i], step_total = 0, step_completion = 0;
				if(step.type == "basic_form")
				{
					step_completion = 6;
					let inp = ["assettype", "startyear", "endyear", "heating_system"];
                    step_total = 10;
                    if(this.selected_survey != null && ['existing_before_dec2020', 'existing_after_dec2020'].indexOf(this.selected_survey.survey_type) != -1)
                    {
                        inp.push('permityear');
                        step_total = 11;
                    }
					for(let key in inp)
					{
						if(inp[key] in step && step[inp[key]] != null && String(step[inp[key]]).length > 0)
						{
							step_completion += 1;
						}
					}
				}
				else if(step.type == "basic_questionnaire")
				{
					let valid = 0, step_counter = 0;
					for(let q = 0; q < step.questions.length; q++)
					{
						if(!this.isValid(step.questions[q], survey.steps))
						{
							continue;
						}
						if(
							(step.questions[q].radio_value && step.questions[q].upload_value.length > 0) ||
							(step.questions[q].radio_value == false) || 
							(step.questions[q].radio_value != null && String(step.questions[q].radio_value).toUpperCase() == 'NA')
						)
						{
							step_completion += 1;
						}
						valid += 1;
						if(step.questions[q].option != 'b')
						{
							step_counter += 1
						};

                        valid += this.getChildrenSteps(step.questions[q]);
                        step_completion += this.getChildrenCompletion(step.questions[q]);
						step.questions[q]["step_counter"] = step_counter;
					}
					step_total += valid;
				}
				else if(step.type == 'basic_list')
				{
					continue;
				}

                step["completion"] = step_completion;
				step["total"] = step_total;
				completion += (25 * (step_completion / step_total));
			}
		}
		survey["completion_fe"] = completion;
	}

	getSurveys()
	{
		this.loading = true;
		this.api.async(
			[
				"/assets/LEED:"+ this.leed_id + "/eutaxonomy/",
				"/assets/LEED:"+ this.leed_id + "/?unit=" + (this.appData.get('unit_preference').gfa_unit == 'sqm' ? 'SI' : 'IP')
			]
		).subscribe(
			data =>
			{
				this.loading = false;
				this.appData.set('buildingData', data[1]);
				this.surveys = this.insertData(data[0]);
				
				for(let i = 0; i < this.surveys.length; i++)
				{
					this.getCompletion(this.surveys[i]);
				}
			},
			error =>
			{
				this.loading = false;
			}
		);
	}
	
	openDownload(type: any)
	{
		this.download_type = type.survey_type;
		this.download_survey.open({ windowClass: 'certificate_modal', size: 'lg' });
	}

	newSurvey()
	{
		this.new_survey.open({ windowClass: 'certificate_modal', size: 'lg' });
	}

	closeSurvey(type: string)
	{
		switch(type)
		{ 
			case 'new_survey':
			{ 
				this.new_survey.close();
				break; 
			}
			case 'download_survey':
			{ 
				this.download_survey.close();
				break; 
			}
			case 'check_survey':
			{ 
				this.check_survey.close();
				break; 
			}
		} 
	}

	getDocIds(uploads: any)
	{
		let pkeys: any = [];
		if(uploads == undefined)
		{
			return pkeys;
		}
		for(let i = 0; i < uploads.length; i++)
		{
			pkeys.push(uploads[i].id);
		}
		return pkeys;
	}

	deleteFeed(feed: any, index?: number)
	{
		this.loading = true;
		this.api.delete('/assets/LEED:'+ this.leed_id + '/notificationitems/', {
			"foreign_id": feed.foreign_id
		}).subscribe(
			//success handler
			data =>{
				this.loading = false;
			},
			//error handler
			data =>{
				this.loading = false;
			}
		);
	};

	initFeed()
	{
		this.api.get(
			'/assets/LEED:'+ this.leed_id +'/notificationitems/'
		).subscribe(
			response =>
			{
				var client = stream.connect(response.stream_key, null, response.app_id);
				var notification = client.feed(response.feed_name, response.feed_user, response.token);
				
				for(var i = 0; i < response.activities.length; i++)
				{
					if(response.activities[i].foreign_id.indexOf("eu_taxonomy") != -1)
					{
						var time = moment(response.activities[i].time);
						var date = moment(new Date);
						if(time.diff(date, 'days') > 1)
						{
							this.deleteFeed(response.activities[i]);
						}
						else
						{
							this.feed_report.push(response.activities[i]);
						}
					}
				};

				this.feed_report = this.feed_report.sort(function(a: any,b: any) 
				{ 
					return new Date(a.time).getTime() - new Date(b.time).getTime() 
				});

				var subscription = notification.subscribe((data: any) =>
				{
					for(var d = 0; d < data.deleted.length; d++)
					{
						for(var a = 0; a < this.feed_report.length; a++)
						{
							if(this.feed_report[a].id == data.deleted[d])
							{
								this.feed_report.splice(a, 1);
							}
						}
					}

					if(data.new.length > 0)
					{
						if(data.new[0].foreign_id.indexOf("eu_taxonomy") != -1)
						{
							this.feed_report.push(data.new[0]);
						}
					}
					
					this.feed_report = this.feed_report.sort(function(a: any,b: any) 
					{ 
						return new Date(a.time).getTime() - new Date(b.time).getTime() 
					});

					this.global.refreshCycle();
				});
			},
			error =>
			{

			}
		);
	};

	createReport(type: string)
	{
		var url = Config.basic_api_url + "/assets/LEED:"+ this.leed_id +"/report/eu-taxonomy/?access-token=<access-token>&subscription-key="+ Config.sub_key + "&type="+ type;
		
		var payload = {
			"source_url": url,
			"doc_category": "eu_taxonomy_report_" + type,
			"file_name": "EU Taxonomy Report",
			"callback": "eu_taxonomy_report",
			"crawl": false
		};
		this.loading = true;
		this.api.post('/assets/LEED:'+ this.leed_id +'/createPDF/', payload).subscribe(
			data =>
			{
				this.loading = false;
			},
			data =>
			{
				this.loading = false
				this.alertService.alert('error', 'Something went wrong. Try again.', 5);
			}
		);
	}

    getChildrenPayload(option: any, payload: any, parentStatus: boolean)
    {
        if(option.children != undefined)
        {
            for(let i = 0; i < option.children.length; i++)
            {
				payload[option.children[i].key] = option.children[i].radio_value;
				payload[option.children[i].key + "_reason"] = option.children[i].textarea_value;
				payload[option.children[i].key + "_upload"] = this.getDocIds(option.children[i].upload_value);

				if(parentStatus != true)
				{
					payload[option.children[i].key] = null;
					payload[option.children[i].key + "_reason"] = null;
					payload[option.children[i].key + "_upload"] = [];
				}

                if(option.children[i].children != undefined)
                {
                    payload = this.getChildrenPayload(option.children[i], payload, payload[option.children[i].key]);
                }
            }
        }
        return payload;
    }

	saveSurvey(submit?: boolean)
	{
		if(this.uploading)
		{
			this.alertService.alert('info', 'Please wait for files to be uploaded', 5);
			return;
		}

		let payload: any = {};
		payload["survey_type"] = this.selected_survey.survey_type;
		payload["name"] = this.appData.get('buildingData').name;
		payload["street"] = this.appData.get('buildingData').street;
		payload["city"] = this.appData.get('buildingData').city;
		payload["state"] = this.appData.get('buildingData').state;
		payload["country"] = this.appData.get('buildingData').country;
		payload["zip_code"] = this.appData.get('buildingData').zip_code;
		payload["assettype"] = this.selected_survey.steps[0].assettype;
		payload["gross_area"] = this.appData.get('buildingData').gross_area;

		if(this.selected_survey.steps[0].startyear != null)
			payload["startyear"] = this.selected_survey.steps[0].startyear;
		if(this.selected_survey.steps[0].endyear != null)
			payload["endyear"] = this.selected_survey.steps[0].endyear;
		if(this.selected_survey.steps[0].heating_system != null)
			payload["heating_system"] = this.selected_survey.steps[0].heating_system;

        if(['existing_before_dec2020', 'existing_after_dec2020'].indexOf(this.selected_survey.survey_type) != -1)
        {
            if(this.selected_survey.steps[0].permityear != null)
			{
                payload["permityear"] = this.selected_survey.steps[0].permityear;
            }
        }

		if(submit == undefined)
		{
			submit = false;
		}
		else
		{
			payload["surveycompleted"] = submit;
		}

		for(let i = 1; i <= 3; i++)
		{
			let questions = this.selected_survey.steps[i].questions;
			for(let j = 0; j < questions.length; j++)
			{
				payload[questions[j].key] = questions[j].radio_value;
				payload[questions[j].key + "_reason"] = questions[j].textarea_value;
				payload[questions[j].key + "_upload"] = this.getDocIds(questions[j].upload_value);

				if(questions[j].has_model && questions[j].upload_label_model != null)
				{
					payload[questions[j].key + "_reading"] = questions[j].upload_label_model;
				}
				payload = this.getChildrenPayload(questions[j], payload, payload[questions[j].key]);
				if(questions[j].flipped != undefined && questions[j].flipped)
				{
					payload[questions[j].key] = !payload[questions[j].key];
				}
			}
		}

		if(submit)
		{
			let form_data = new FormData(), file: any;
			let mimeType = 'text/html';
			let html_content = this.styles + $('#certificate_score').html();
			if(this.global.getBrowser().ie == true || this.global.getBrowser().safari == true)
			{
				file = new Blob([html_content], { type: mimeType});
				file.lastModifiedDate = new Date();
				payload["file"] = file;
			}
			else
			{
				file = new File([html_content], "file.html", {type: mimeType, lastModified: <any>new Date()});
				payload["file"] = file;
			}

			for(let key in payload)
			{
				if(key.indexOf('upload') != -1)
				{
					form_data.append(key, JSON.stringify(payload[key]));
				}
				else
				{
					form_data.append(key, payload[key]);
				}
			}
			payload = form_data;
		}

		let custom_basic_config_header = 
		{
			headers: 
			{
				"responseType": submit ? "arraybuffer" : "application/json",
				"Ocp-Apim-Subscription-Key": Config.sub_key,
				"Authorization": "Bearer " + this.appData.get('token')
			}
		};

		this.loading = true;
		this.api.post(
			"/assets/LEED:"+ this.leed_id +"/eutaxonomy/",
			payload,
			custom_basic_config_header
		).subscribe(
			data =>
			{
				this.loading = false;
				if(submit)
				{
					this.createReport(this.selected_survey.survey_type);
				}
				this.closeSurvey('check_survey');
				this.exitSurvey();
			},
			error =>
			{
				this.loading = false;
			}
		);
	}

	exitSurvey()
	{
		Config.hide_sidebar = false;
		this.selected_survey = null;
		this.getSurveys();
	}

	previousStep()
	{
		if(this.current_step == 0)
		{
			return;
		}
		this.picker_loaded = false;
		this.current_step -= 1;
	}

	changeStep(step: number)
	{
		this.current_step = step;
		this.picker_loaded = false;
		this.check_survey.close();
	}
	enableFdatePicker()
	{
		if(this.picker_loaded == false)
		{
			this.picker_loaded = true;
			(<any>$('.year-inp')).fdatepicker(
			{
				format: 'yyyy',
				startView: 'decade',
				minView: 'decade', 
    			maxView: 'decade'
			}).on('changeDate', (ev: any) =>
			{
				if(ev.target.classList.contains('startyear'))
				{
					this.selected_survey.steps[this.current_step].startyear = $('#startyear').val();
				}
				else if(ev.target.classList.contains('endyear'))
				{
					this.selected_survey.steps[this.current_step].endyear = $('#endyear').val();
				}
				else if(ev.target.classList.contains('permityear'))
				{
					this.selected_survey.steps[this.current_step].permityear = $('#permityear').val();
				}

				this.verifyYears(this.selected_survey.steps[this.current_step].startyear, this.selected_survey.steps[this.current_step].endyear);
			});
		}
	}

	getStatus(step: any, itr?: any)
	{
		if(step.type == 'basic_list')
		{
			return '';
		}
		else if(step.completion != step.total)
		{
			itr.classList.add('unanswered_questions');
			this.errors = true;
		}
		else if(step.completion == step.total)
		{
			itr.classList.remove('unanswered_questions');
		}
		return step.completion + "/" + step.total + " questions answered";
	}

	checkSurvey(mode: string)
	{
		this.mode = mode;
		this.errors = false;
		this.getCompletion(this.selected_survey);
		this.check_survey.open({ windowClass: 'certificate_modal', size: 'lg' });
	}
	
	nextStep()
	{
		if(this.current_step == (this.selected_survey.steps.length - 1))
		{
			return;
		}
		this.picker_loaded = false;
		this.current_step += 1;
	}

	changeRadio(value: any, question: any, key?: string)
	{
		key = key == undefined ? 'radio_value' : 'assettype';
		question[key] = value;
		
		if(["yes", "no", "na"].indexOf(value) != -1)
		{
			question.textarea_value = null;
		}
	}

	editSurvey(type: any)
	{
		Config.hide_sidebar = true;
		this.current_step = 0;
		this.selected_survey = type;
		this.selected_survey.steps[this.current_step].gross_area = this.appData.get('buildingData').gross_area;
		this.closeSurvey('new_survey');
		window.scrollTo({top: 0, behavior: 'smooth'});
	}

	chooseSurvey(type: any)
	{
		for(let i = 0; i < this.surveys.length; i++)
		{
			if(this.surveys[i].id != undefined && this.surveys[i].survey_type == type.survey_type)
			{
				this.editSurvey(this.surveys[i]);
				return;
			}
		}
		Config.hide_sidebar = true;
		this.current_step = 0;
		this.selected_survey = this.global.copy(type);
		this.selected_survey.steps[0].gross_area = this.appData.get('buildingData').gross_area;
		this.selected_survey['id'] = this.global.generateString(10);
		this.selected_survey.steps[this.current_step].gross_area = this.appData.get('buildingData').gross_area;
		this.closeSurvey('new_survey');
		this.getCompletion(this.selected_survey);
		window.scrollTo({top: 0, behavior: 'smooth'});
	}

	selectFile(key: string)
	{
		$('.' + key).click();
	}

	fileSelected(elem: any, question: any)
	{
		let form_data: any = new FormData();
		form_data.append('action_file', $(elem)[0].files[0]);
		let filePath: any = $(elem).val();
		filePath = filePath.replace("/\\/", "\\\\");
		let index = filePath.lastIndexOf("\\");
		filePath = filePath.substring(index + 1, filePath.length);

		let custom_basic_config_header = 
		{
			headers: 
			{
				"responseType": "arraybuffer",
				"Ocp-Apim-Subscription-Key": Config.sub_key,
				"Authorization": "Bearer " + this.appData.get('token')
			}
		};
		form_data.append('upload_category', question.key + "_upload");
		question.upload_value.push({
			"doc_key": form_data.get('action_file').name,
			"status": "uploading"
		});
		this.uploading = true;

		this.api.post('/assets/LEED:'+ this.appData.get('leed_id') +'/uploadS3/?upload_category=' + question.key + "_upload", form_data, custom_basic_config_header).subscribe(
			//success handler
			response =>
			{
				question.upload_value[question.upload_value.length - 1].status = 'complete';
				question.upload_value[question.upload_value.length - 1].id = response.id;
				this.uploading = false;
				this.alertService.alert('success', 'File successfully uploaded.', 5);
			},
			//error handler
			response =>
			{
				this.uploading = false;
				this.alertService.alert('error', 'Error uploading file. Please try again.', 5);
			}
		);
	}

	removeFile(idx: number, list: any)
	{
		list.splice(idx, 1);
		this.alertService.alert('success', 'File removed.', 5);
	}

	isValid(question: any, steps?: any)
	{
		return true;
		// let condition = question.condition;
		// if(condition == undefined)
		// {
		// 	return true;
		// }
		// let variable = steps[0][question.condition_key];
		// return eval(condition);
	}

	downloadSurvey(type: string)
	{
		if(type == 'documentation')
		{
			this.global.anchorDownload("Documentation.zip", Config.basic_api_url + "/assets/LEED:"+ this.leed_id +"/eutaxonomy/documents/?access-token=" + this.appData.get('token') + '&subscription-key=' + Config.sub_key + "&survey_type=" + this.download_type);
		}
		else if(type == 'summary')
		{
			this.api.get(
				'/assets/LEED:'+ this.appData.get('leed_id') + '/s3documents/'
			).subscribe(
				data =>
				{
					for(let i = 0; i < data.length; i++)
					{
						if(data[i].doc_category == "eu_taxonomy_certificate_" + this.download_type)
						{
							this.global.downloadFile(data[i]);
						}
					}
				}
			);
		}
	}

	verifyYears(start: any, end: any)
	{
		this.error_year = false;
		if(parseInt(start) > parseInt(end))
		{
			this.error_year = true;
		}
	}

}
